import { calculateGridHeight } from '@/services/calculate'
import { formatCurrency } from '@/services/convert'
import { highlightLinkRows } from '@/services/grid'
import { AgGridVue } from 'ag-grid-vue'
import CurrencyRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
  },
  props: ['takeoffs', 'columns', 'costDetails', 'tableHeight'],
  data() {
    return {
      data: [],
      gridOptions: {
        suppressCellSelection: true,
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        rowSelection: 'multiple',
        tooltipShowDelay: 0,
        defaultColDef: {
          suppressMovable: true,
          singleClickEdit: false,
          menuTabs: ['filterMenuTab'],
        },
      },
      columnDefs: null,
      frameworkComponents: null,
      width: '100%',
      height: this.tableHeight,
      formatCurrency: formatCurrency,
    }
  },
  beforeMount() {
    this.loadingConfig()
    this.postSort = rowNodes => {
      const takeoffs = []
      for (let i = 0; i < rowNodes.length; i++) {
        takeoffs.push(rowNodes[i].data)
      }
      this.data = [...takeoffs]
    }
  },
  mounted() {
    this.loadingConfig()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = {
        customFilter: CustomFilter,
        costPriceCellRenderer: CurrencyRenderer,
        toolTipRenderer: ToolTipRenderer,
      }
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLocked) return false
          else return true
        }
      }
    },

    getData(params) {
      const displayColumns = this.columns
      displayColumns.map(col => {
        const align = col.field === 'unitCost' ? 'right' : 'left'
        if (col.headerName) {
          col.cellStyle = param => highlightLinkRows(param, align)
          col.filter = 'customFilter'
        }
        return col
      })
      params.api.setColumnDefs(displayColumns)
      params.api.sizeColumnsToFit()
      params.api.setRowData(this.takeoffs)
    },

    getWindowSize() {
      this.height = calculateGridHeight('gridTable', true, false)
    },

    gridSizeChanged(e) {
      this.gridOptions.api.sizeColumnsToFit()
    },
  },
}
